import { StoreReview } from '@/components/StoreReview';
import { useDataLayer } from '@/hooks/useDataLayer';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { StoreReview as Review } from '@/types';
import * as Styled from './ReviewsCarousel.styled';

interface ImageCarouselProps {
  reviews: Review[];
}

export const ReviewsCarousel = ({ reviews }: ImageCarouselProps) => {
  // One of the limitations of this carousel library is that one has to specify
  // the number of items per page instead of having it calculated responsively.
  // I've determined several breakpoints in order to specify the optimum number
  // of items per page. It's a rather brittle solution but works.
  const breakpoint4 = useMediaQuery('(width >= 70rem)');
  const breakpoint3 = useMediaQuery('(width >= 62rem)');
  const breakpoint2 = useMediaQuery('(width >= 53rem)');
  const breakpoint1 = useMediaQuery('(width >= 36rem)');
  const breakpoint0 = useMediaQuery('(width >= 33rem)');

  const getItemsPerPage = () => {
    if (breakpoint4) {
      return 3;
    }

    if (breakpoint3) {
      return 2.6;
    }

    if (breakpoint2) {
      return 2.2;
    }

    if (breakpoint1) {
      return 1.6;
    }

    if (breakpoint0) {
      return 1.25;
    }

    return 1.12;
  };

  const itemsPerPage = getItemsPerPage();
  const { mediaInteract } = useDataLayer();

  return (
    <Styled.Carousel
      aria-label="Eason reviews"
      itemsPerPage={itemsPerPage}
      loop={reviews.length > itemsPerPage ? 'infinite' : false}
      onActivePageIndexChange={({ index }) =>
        mediaInteract('reviews-carousel', 'navigate', index)
      }
      spaceBetweenItems={breakpoint1 ? '14px' : '0px'}
    >
      <Styled.Main>
        {reviews.map(review => (
          <Styled.Item key={review.reviewId}>
            <StoreReview review={review} />
          </Styled.Item>
        ))}
      </Styled.Main>
    </Styled.Carousel>
  );
};
